class FreyRanchPopup extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.dialog = this.querySelector('[role="dialog"]');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('.frey-ranch__popup-close').addEventListener('click', this.close.bind(this));
    this.querySelector('.frey-ranch__popup-overlay').addEventListener('click', () => this.close(false));

    this.summaryToggle.setAttribute('role', 'button');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.detailsContainer.hasAttribute('open') ? this.close() : this.open();
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');
    trapFocus(this.dialog);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('frey-ranch-popup', FreyRanchPopup);
